// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"b87b1ccf","352":"b87b1ccf","378":"a7e38aa8"}[chunkId] + ".chunk.css";
};